module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.EditLoading),
      expression: "EditLoading"
    }],
    attrs: {
      "gutter": 20
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "80px"
    },
    model: {
      value: (_vm.AdsForm),
      callback: function($$v) {
        _vm.AdsForm = $$v
      },
      expression: "AdsForm"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "投放范围"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.AdsForm.delivery_range),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "delivery_range", $$v)
      },
      expression: "AdsForm.delivery_range"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "disabled": "",
      "label": "DEFAULT"
    }
  }, [_vm._v("默认")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "disabled": "",
      "label": "UNION"
    }
  }, [_vm._v("穿山甲")])], 1)], 1), _vm._v(" "), (_vm.AdsForm.delivery_range == 'UNION') ? _c('el-form-item', {
    attrs: {
      "label": "投放形式"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.AdsForm.union_video_type),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "union_video_type", $$v)
      },
      expression: "AdsForm.union_video_type"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "disabled": "",
      "label": "REWARDED_VIDEO"
    }
  }, [_vm._v("激励视频")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "disabled": "",
      "label": "ORIGINAL_VIDEO"
    }
  }, [_vm._v("原生")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "下载方式"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.AdsForm.download_type),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "download_type", $$v)
      },
      expression: "AdsForm.download_type"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "DOWNLOAD_URL"
    }
  }, [_vm._v("下载链接")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "EXTERNAL_URL"
    }
  }, [_vm._v("落地页")])], 1)], 1), _vm._v(" "), (_vm.AdsForm.download_type == 'EXTERNAL_URL') ? _c('el-form-item', {
    attrs: {
      "label": "链接地址"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.AdsForm.external_url),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "external_url", $$v)
      },
      expression: "AdsForm.external_url"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.AdsForm.download_type == 'DOWNLOAD_URL') ? _c('el-form-item', {
    attrs: {
      "label": "下载地址"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": ""
    },
    model: {
      value: (_vm.AdsForm.download_url),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "download_url", $$v)
      },
      expression: "AdsForm.download_url"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.AdsForm.download_type == 'DOWNLOAD_URL') ? _c('el-form-item', {
    attrs: {
      "label": "应用包名"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": ""
    },
    model: {
      value: (_vm.AdsForm.package),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "package", $$v)
      },
      expression: "AdsForm.package"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "转化ID"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": ""
    },
    model: {
      value: (_vm.AdsForm.convert_id),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "convert_id", $$v)
      },
      expression: "AdsForm.convert_id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.AdsForm.audience.gender),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm.audience, "gender", $$v)
      },
      expression: "AdsForm.audience.gender"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "NONE"
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "GENDER_MALE"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "GENDER_FEMALE"
    }
  }, [_vm._v("女")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('el-form-item', {
    attrs: {
      "label": "年龄"
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.AdsForm.audience.age),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm.audience, "age", $$v)
      },
      expression: "AdsForm.audience.age"
    }
  }, [_c('el-checkbox-button', {
    attrs: {
      "label": "AGE_BELOW_18"
    }
  }, [_vm._v("<18")]), _vm._v(" "), _c('el-checkbox-button', {
    attrs: {
      "label": "AGE_BETWEEN_18_23"
    }
  }, [_vm._v("18-23")]), _vm._v(" "), _c('el-checkbox-button', {
    attrs: {
      "label": "AGE_BETWEEN_24_30"
    }
  }, [_vm._v("24-30")]), _vm._v(" "), _c('el-checkbox-button', {
    attrs: {
      "label": "AGE_BETWEEN_31_40"
    }
  }, [_vm._v("31-40")]), _vm._v(" "), _c('el-checkbox-button', {
    attrs: {
      "label": "AGE_BETWEEN_41_49"
    }
  }, [_vm._v("41-49")]), _vm._v(" "), _c('el-checkbox-button', {
    attrs: {
      "label": "AGE_ABOVE_50"
    }
  }, [_vm._v(">=50")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "定向人群"
    }
  }, [_c('el-select', {
    staticClass: "custom_audience",
    attrs: {
      "size": "small",
      "multiple": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.AdsForm.audience.retargeting_tags_include),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm.audience, "retargeting_tags_include", $$v)
      },
      expression: "AdsForm.audience.retargeting_tags_include"
    }
  }, _vm._l((_vm.custom_audience), function(item) {
    return _c('el-option', {
      key: item.custom_audience_id,
      attrs: {
        "label": item.name,
        "value": item.custom_audience_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排除人群"
    }
  }, [_c('el-select', {
    staticClass: "custom_audience",
    attrs: {
      "size": "small",
      "multiple": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.AdsForm.audience.retargeting_tags_exclude),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm.audience, "retargeting_tags_exclude", $$v)
      },
      expression: "AdsForm.audience.retargeting_tags_exclude"
    }
  }, _vm._l((_vm.custom_audience), function(item) {
    return _c('el-option', {
      key: item.custom_audience_id,
      attrs: {
        "label": item.name,
        "value": item.custom_audience_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "行为兴趣"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.AdsForm.ad_tag),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "ad_tag", $$v)
      },
      expression: "AdsForm.ad_tag"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "-1"
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "-2"
    }
  }, [_vm._v("系统推荐")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "网络"
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.AdsForm.audience.ac),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm.audience, "ac", $$v)
      },
      expression: "AdsForm.audience.ac"
    }
  }, [_c('el-checkbox-button', {
    attrs: {
      "label": "WIFI"
    }
  }, [_vm._v("WIFI")]), _vm._v(" "), _c('el-checkbox-button', {
    attrs: {
      "label": "2G"
    }
  }, [_vm._v("2G")]), _vm._v(" "), _c('el-checkbox-button', {
    attrs: {
      "label": "3G"
    }
  }, [_vm._v("3G")]), _vm._v(" "), _c('el-checkbox-button', {
    attrs: {
      "label": "4G"
    }
  }, [_vm._v("4G")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "最低系统版本",
      "label-width": "120px"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.AdsForm.version),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "version", $$v)
      },
      expression: "AdsForm.version"
    }
  }, _vm._l((_vm.versionList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('el-form-item', {
    attrs: {
      "label": "出价方式"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small",
      "disabled": ""
    },
    model: {
      value: (_vm.AdsForm.smart_bid_type),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "smart_bid_type", $$v)
      },
      expression: "AdsForm.smart_bid_type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "SMART_BID_CUSTOM"
    }
  }, [_vm._v("手动")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "SMART_BID_CONSERVATIVE"
    }
  }, [_vm._v("自动")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AdsForm.smart_bid_type == 'SMART_BID_CUSTOM'),
      expression: "AdsForm.smart_bid_type=='SMART_BID_CUSTOM'"
    }],
    attrs: {
      "label": "目标出价"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.AdsForm.cpa_bid),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "cpa_bid", $$v)
      },
      expression: "AdsForm.cpa_bid"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("元")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "投放方式"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.AdsForm.flow_control_mode),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "flow_control_mode", $$v)
      },
      expression: "AdsForm.flow_control_mode"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "FLOW_CONTROL_MODE_FAST"
    }
  }, [_vm._v("优先跑量")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "FLOW_CONTROL_MODE_BALANCE"
    }
  }, [_vm._v("均衡投放")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "FLOW_CONTROL_MODE_SMOOTH"
    }
  }, [_vm._v("优先低成本")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预算"
    }
  }, [_c('el-input', {
    staticClass: "input-with-select",
    attrs: {
      "size": "small",
      "placeholder": "设置预算金额"
    },
    model: {
      value: (_vm.AdsForm.budget),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "budget", $$v)
      },
      expression: "AdsForm.budget"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "slot": "prepend",
      "disabled": "",
      "placeholder": "请选择"
    },
    slot: "prepend",
    model: {
      value: (_vm.AdsForm.budget_mode),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "budget_mode", $$v)
      },
      expression: "AdsForm.budget_mode"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "日预算",
      "value": "BUDGET_MODE_DAY"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "总预算",
      "value": "BUDGET_MODE_TOTAL"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "投放时间"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.AdsForm.schedule_type),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "schedule_type", $$v)
      },
      expression: "AdsForm.schedule_type"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "SCHEDULE_FROM_NOW"
    }
  }, [_vm._v("从今天起长期投放")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "SCHEDULE_START_END"
    }
  }, [_vm._v("设置开始和结束时间")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AdsForm.schedule_type == 'SCHEDULE_START_END'),
      expression: "AdsForm.schedule_type=='SCHEDULE_START_END'"
    }]
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "44%"
    },
    attrs: {
      "value-format": "yyyy-MM-dd HH:mm",
      "size": "small",
      "type": "date",
      "placeholder": "开始日期"
    },
    model: {
      value: (_vm.AdsForm.start_time),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "start_time", $$v)
      },
      expression: "AdsForm.start_time"
    }
  }), _vm._v("-\n\t\t\t\t "), _c('el-date-picker', {
    staticStyle: {
      "width": "44%"
    },
    attrs: {
      "value-format": "yyyy-MM-dd HH:mm",
      "size": "small",
      "type": "date",
      "placeholder": "结束日期"
    },
    model: {
      value: (_vm.AdsForm.end_time),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "end_time", $$v)
      },
      expression: "AdsForm.end_time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "投放时段"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.AdsForm.schedule_time),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "schedule_time", $$v)
      },
      expression: "AdsForm.schedule_time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "计划名称"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.AdsForm.name),
      callback: function($$v) {
        _vm.$set(_vm.AdsForm, "name", $$v)
      },
      expression: "AdsForm.name"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "demo-drawer__footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.cancelOpen
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": "",
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.addAds
    }
  }, [_vm._v("新建")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": _vm.saveEditAds
    }
  }, [_vm._v("仅修改保存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-605423ed"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/adv/model/edit/ads.vue
// module id = 1103
// module chunks = 38